"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAFF_SESSION_REFRESH_CODES = exports.SESSION_REFRESH_CODES = void 0;
exports.apiStatusCode = apiStatusCode;
exports.isSessionRejection = isSessionRejection;
exports.isTemporaryFailure = isTemporaryFailure;
/**
 * OTURUM KARARI mı, GEÇİCİ HATA mı? (tech-lead 17B+17E Yüksek-1)
 *
 * Panel kapısında kapatılan sınıfın ikizi: "yetkin yok" ile "şu an karar
 * veremedim" AYNI ŞEY DEĞİLDİR. Yenileme isteği 401/403 dönerse sunucu
 * oturum hakkında KARAR VERMİŞTİR — jeton düşürülür. 429/5xx/ağ hatası
 * KARAR DEĞİLDİR: jeton korunur, kullanıcı girişe atılmaz.
 *
 * Mobilde bu ayrımın olmaması geri dönüşsüzdü: güvenli depodaki yenileme
 * jetonu silinince uygulamayı uçak modunda açan kullanıcı yeniden OTP
 * girmek zorunda kalıyordu (webde jeton HttpOnly çerezde kaldığı için
 * kurtarılabiliyor). Kural TEK YERDE durur; web ve mobil aynı işlevi çağırır.
 */
const error_codes_1 = require("./error-codes");
/**
 * KORUMALI BİR İSTEK HANGİ KODDA YENİLEMEYE GİDER? (sıra 45)
 *
 * Eskiden yalnız `UNAUTHENTICATED` ve `TOKEN_EXPIRED` yeniliyordu. Koruyucu
 * iptal edilmiş oturumu `TOKEN_INVALID` ile reddettiği için yenileme hiç
 * gitmiyor, uzaktan kapatılan oturumda uygulama bayat ekranda kalıyor ve her
 * yoklama 401 alıyordu. Artık koruyucunun ürettiği dört kodun dördü de BİR
 * KEZ yeniler. Oturumun ölü olduğuna YENİLEME UCU karar verir: o uç
 * reddederse (`isSessionRejection`) istemci kabuğu kapatır. Yenileme isteği
 * bu kümeyle değerlendirilmez, kendi cevabı karardır: döngü yapısal olarak
 * imkânsızdır.
 *
 * Kodların sunucudaki her üretim yeri ve istemcinin tepkisi
 * `apps/api/src/common/guards/session-code-inventory.guard.spec.ts`te
 * enumere edilir; "yenile" diye sınıflanan yerin kodu bu kümede olmak zorundadır.
 */
exports.SESSION_REFRESH_CODES = [
    error_codes_1.ERROR_CODES.UNAUTHENTICATED,
    error_codes_1.ERROR_CODES.TOKEN_EXPIRED,
    error_codes_1.ERROR_CODES.TOKEN_INVALID,
    error_codes_1.ERROR_CODES.SESSION_REVOKED,
];
/**
 * PERSONEL OTURUMUNUN YENİLEME KÜMESİ (panel küçük işler 1 · B-02).
 *
 * Panel ayrı bir kimliktir ve ayrı kodlar alır (`STAFF_*`): koruyucu süresi
 * dolan erişim jetonuna `STAFF_SESSION_EXPIRED`, eksik/bozuk/iptal edilmiş
 * jetona `STAFF_UNAUTHENTICATED` döner. Ürün kümesi bu iki kodu TANIMAZ;
 * panel `createApiSaga`yı ürün kümesiyle kurduğu için 15 dakikadan sonra hiç
 * yenileme gitmiyor, her ekran "Panel oturumunun süresi doldu" yazıp
 * kalıyordu. Panel bu kümeyi `refreshCodes` ile verir; iki küme ayrı kalır,
 * ürün istemcisi personel kodunda, panel ürün kodunda yenilemez.
 *
 * Koruyucunun her üretim yeri
 * `apps/api/src/modules/staff-auth/staff-session-code-inventory.guard.spec.ts`te
 * enumere edilir; "yenile" diye sınıflanan yerin kodu bu kümede olmak zorundadır.
 */
exports.STAFF_SESSION_REFRESH_CODES = [
    error_codes_1.ERROR_CODES.STAFF_UNAUTHENTICATED,
    error_codes_1.ERROR_CODES.STAFF_SESSION_EXPIRED,
];
/** `ApiError`, ham gövde ya da bilinmeyen hata → HTTP durum kodu (yoksa null). */
function apiStatusCode(error) {
    if (typeof error !== 'object' || error === null)
        return null;
    const direct = statusOf(error);
    if (direct !== null)
        return direct;
    // `ApiError` sunucu gövdesini `.body` altında taşır.
    if ('body' in error)
        return statusOf(error.body);
    return null;
}
/**
 * Sunucu oturumu REDDETTİ mi? Yalnızca 401/403 kimlik kararıdır; 429, 5xx,
 * ağ hatası ve gövdesiz hatalar `false` döner (karar yok).
 */
function isSessionRejection(error) {
    const status = apiStatusCode(error);
    return status === 401 || status === 403;
}
/**
 * GEÇİCİ hata mı? (QA 17B+17E P2 sınıf taraması — `isSessionRejection`in ikizi)
 *
 * `isSessionRejection` "sunucu HAYIR dedi mi" sorusunu yanıtlar; bu işlev
 * "sunucu ŞU AN yanıtlayamadı mı" sorusunu. Kural tek yerde durur ve okuyan
 * her yüzey aynı sınırı kullanır:
 *   - 408 (istek zaman aşımı), 425, 429 (hız sınırı) ve tüm 5xx → GEÇİCİ.
 *   - Diğer 4xx KALICIDIR: 400 hatalı kimlik biçimi, 404 yok — bunlar tekrar
 *     denemekle düzelmez, "bulunamadı" doğru cevaptır (public konuşmacı
 *     sayfasında `yok` kimliği 400 döndürüyor ve 404 gösterilmelidir).
 *   - Ağ hatası durum kodu ÜRETMEZ; çağıranın `catch` dalı geçici sayar.
 */
function isTemporaryFailure(error) {
    const status = apiStatusCode(error);
    if (status === null)
        return false;
    return status === 408 || status === 425 || status === 429 || status >= 500;
}
function statusOf(value) {
    if (typeof value !== 'object' || value === null || !('statusCode' in value))
        return null;
    const { statusCode } = value;
    return typeof statusCode === 'number' ? statusCode : null;
}
//# sourceMappingURL=session-decision.js.map